export default __webpack_public_path__ + "static/media/aiSecurityRealcase-mobile-en.f013ad10.jpg";